export function StatusBadge({value}: {value: string}) {
  const normalized = value.toUpperCase();
  const tone = ["ACTIVE", "LIVE", "UP", "VALIDATED"].includes(normalized)
    ? "positive" : ["SUBMITTED", "DRAFT", "DEGRADED", "PENDING"].includes(normalized)
    ? "attention" : ["REJECTED", "DOWN", "ERROR", "DENIED"].includes(normalized)
    ? "negative" : "neutral";
  return <span className={`status-pattern status-${tone}`}>
    <span aria-hidden="true">{tone === "positive" ? "✓" : tone === "attention" ? "◆" : tone === "negative" ? "!" : "•"}</span>
    {value.replaceAll("_", " ")}
  </span>;
}
